import React from 'react';

interface Props {
  containerClass?: string;
  titleClass?: string;
  leftClass?: string;
  rightClass?: string;
  leftContent: React.ReactElement;
  leftTitle?: string;
  rightContent: React.ReactElement;
  rightTitle?: string;
  contentLink?: React.ReactElement;
}

const TwoColumnsGrid: React.FC<Props> = ({
  leftContent,
  rightContent,
  leftClass = '',
  titleClass = '',
  leftTitle = '',
  rightTitle = '',
  rightClass = '',
  contentLink,
  containerClass = '',
}) => {
  return (
    <div className={`main-grid two-columns-grid ${containerClass}`}>
      <div className={`main-grid-item ${leftClass}`}>
        {leftTitle && <h4 className={`title  ${titleClass}`}>{leftTitle}</h4>}
        {leftContent}
      </div>
      <div className={`main-grid-item ${rightClass}`}>
        {rightTitle && <h4 className={`title  ${titleClass}`}>{rightTitle}</h4>}
        {rightContent}
      </div>
      {contentLink}
      {contentLink && <div className="device-only">{contentLink}</div>}
    </div>
  );
};

export default TwoColumnsGrid;
